// extracted by mini-css-extract-plugin
module.exports = {"container":"container-1t31w","input":"input-1WhOa","label":"label-hFDuR","checked":"checked-2EXjU","required":"required-1T9ft","disabled":"disabled-127eo"};